export const normalizeEnum = (str: string) => {
  const lower = str.toLowerCase().split('_');
  return lower
    .map((el) => el.charAt(0).toUpperCase() + el.slice(1) + ' ')
    .join('')
    .slice(0, -1);
};
